import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Paper from "@material-ui/core/Paper";
import Grid from '@mui/material/Grid';

import Card from "../card";
import { getMediaQuery } from "../../utils/helper";

const useStyles = makeStyles((theme) => {
  const defaultStyle = {
    padding: theme.spacing(1),
    textAlign: "start",
    textShadow: "5px 1px 3px black",
    color: theme.palette.text.secondary,
  };
  return {
    root: {
      flexGrow: 1,
    },
    pointer:{
      cursor:"pointer",
      backgroundColor:'red',
    },
    paper: { ...defaultStyle },
    phone: { ...defaultStyle, padding:'10px', backgroundColor: "#ffff0042" },
    laptop: { ...defaultStyle, backgroundColor: "#ffff0042" },
    desctop: { ...defaultStyle, backgroundColor: "#ffff0042" },
  };
});

function FormRow(props) {
  const {
    styleLaters,
    audioAlphabet,
    hideLogo,
    withWinsIcons,
    gameAlphabet
  } = props;

  const classes = useStyles();
  const media = {
    phone: useMediaQuery(" (min-width: 200px) and (max-width: 480px)"),
    laptop: useMediaQuery("(min-width: 481px) and (max-width: 979px)"),
    desctop: useMediaQuery("(min-width : 980px)"),
  };

  const result = getMediaQuery(media);

    const hiddenLetter  = (letter) => {

     return props.gameAlphabet ? props.gameAlphabet.some((obj)=>{
            if(obj.letter === letter){
                return obj.hidden
            }
            return false
        }) : false;
    }

  return (
    <React.Fragment>
      {styleLaters.map(({ letter, color, src, name }) => {
        return (
          <Grid key={letter} size={{ xs: 12, sm: 6, md: 1.7, lg: 1.7, xl: 2 }}>
            <Paper
              key={letter}
              className={`${classes[result && result[0]]} ${classes.pointer} `}
              elevation={3}
              style={{
                color: `${color}`,
                  visibility: hiddenLetter(letter) ? 'hidden' : 'visible',
              }}
            >
              <Card
                letter={letter}
                src={src}
                name={name}
                audioAlphabet={ gameAlphabet || audioAlphabet}
                hideLogo={hideLogo}
                withWinsIcons={withWinsIcons}
                {...props}
              />
            </Paper>
          </Grid>
        );
      })}
    </React.Fragment>
  );
}

export default FormRow;
